import httpClient from './http.client';
import * as Axios from 'axios';
import { CategoryId } from '../store/modules/event';

class EventService {
  getMainConditions() {
    return [
      { id: 'open', name: 'Aktualne', params: { state: 'open' } },
      {
        id: 'recent_changes',
        name: 'Ostatnie zmiany',
        params: {},
        defaultOrdering: '-task_modified_at',
      },
      { id: 'closed', name: 'Zamknięte', params: { state: 'closed' } },
    ]
  }
  getCategoryConditions() {
    return [
      { id: 'all', code: CategoryId.ALL, name: 'Wszystkie', params: {} },
      {
        id: 'alarm',
        code: CategoryId.ALARM,
        name: 'Alarm',
        params: { category: '1.' },
      },
      { id: 'alarm_intrusion',
        code: CategoryId.ALARM_INTRUSION,
        name: 'Alarm Włamaniowy',
        params: { category: '1.1' },
      },
      { id: 'alarm_fire',
        code: CategoryId.ALARM_FIRE,
        name: 'Alarm Pożarowy',
        params: { category: '1.2' },
      },
      { id: 'alarm_medical',
        code: CategoryId.ALARM_MEDICAL,
        name: 'Alarm Medyczny',
        params: { category: '1.3' },
      },
      { id: 'alarm_panic',
        code: CategoryId.ALARM_PANIC,
        name: 'Alarm Przymusowy',
        params: { category: '1.4' },
      },
      {
        id: 'trouble',
        code: CategoryId.TROUBLE,
        name: 'Awaria',
        params: { category: '4.0' },
      },
      {
        id: 'status',
        code: CategoryId.STATUS,
        name: 'Status',
        params: { category: '2.0' },
      },
      {
        id: 'status_arm',
        code: CategoryId.STATUS_ARM,
        name: 'Uzbrojenia',
        params: { category: '2.1' },
      },
      {
        id: 'status_disarm',
        code: CategoryId.STATUS_DISARM,
        name: 'Rozbrojenia',
        params: { category: '2.2' },
      },
      {
        id: 'end_of_trouble',
        code: CategoryId.END_OF_TROUBLE,
        name: 'Koniec awarii',
        params: { category: '5.0' },
      },
      {
        id: 'test',
        code: CategoryId.TEST,
        name: 'Test',
        params: { category: '6.0' },
      },
      {
        id: 'warning',
        code: CategoryId.WARNING,
        name: 'Uwaga',
        params: { category: '7.0' },
      },
      {
        id: 'service',
        code: CategoryId.SERVICE,
        name: 'Serwis',
        params: { category: '9.0' },
      },
      {
        id: 'edit',
        code: CategoryId.EDIT,
        name: 'Edycja bazy',
        params: { category: '10.0' },
      },
      {
        id: 'physical_security',
        code: CategoryId.PHYSICAL_SECURITY,
        name: 'Ochrona fizyczna',
        params: { category: '11.0' },
      },
      {
        id: 'other',
        code: CategoryId.OTHER,
        name: 'Inne',
        params: { category: '8.0' },
      },
    ];
  }
  getEventOrdering() {
    return [
      { name: 'Data utworzenia', ordering: '-created_at' },
      { name: 'Data modyfikacji', ordering: '-task_modified_at' },
    ]
  }
  getEventRanges() {
    return [
      { id: 'last_30_days', name: 'Ostatnie 30 dni' },
      { id: 'today', name: 'Dziś' },
      { id: 'yesterday', name: 'Wczoraj' },
      { id: 'this_month', name: 'Ten miesiac' },
      { id: 'prev_month', name: 'Poprzedni miesiac' },
      { id: 'last_year', name: 'Ostatni rok' },
      { id: 'custom', name: 'Inny' },
    ];
  }

  buildCodesQuery(category = null, search = null) {
    const params = [];
    if (category) {
      params.push(`category__startswith=${encodeURIComponent(category)}`);
    }
    if (search) {
      // transform spaces to ".* " for server-side regex-like search
      const s = search.replace(/\s+/g, '.* ');
      params.push(`search=${encodeURIComponent(s)}`);
    }
    return params.length ? params.join('&') : '';
  }

  fetchCodes(params = {}) {
    // params: { category, search }
    const query = this.buildCodesQuery(params.category, params.search);
    const url = query ? `v1/events/codes?${query}` : 'v1/events/codes';
    return httpClient.get(url).then((response) => response.data);
  }

  createX(siteId, event) {
    return httpClient.post('v1/sites/' + siteId + '/events', event);
  }
  create({ siteId, code, info, userReported, created_at }) {
    let details = {
      info: info,
    };
    if (userReported) {
      details.reported_by = {
        id: userReported.id,
        full_name: userReported.full_name,
      };
    }
    const event = {
      code: code,
      created_at: created_at,
      details: details,
    };
    return httpClient.post(`v1/sites/${siteId}/events`, event);
  }
  update(event) {
    return httpClient.put(`v1/events/${event.id}`, event);
  }
  delete(event) {
    return httpClient.delete(`v1/events/${event.id}`);
  }
  fetchLasts(limit = 100) {
    return httpClient.get('v1/events' + '?limit=' + limit);
  }
  fetchNew(lastId) {
    return httpClient.get('v1/events' + '?fromId=' + lastId);
  }
  fetchSiteEvents(siteId, params) {
    const query = new URLSearchParams(params).toString();
    return httpClient.get(`v1/sites/${siteId}/events?${query}`);
  }
  fetchEvents(params = null) {
    const query = new URLSearchParams(params).toString();
    return httpClient.get(`v1/events?${query}`);
  }
  fetch(eventId) {
    return httpClient.get('v1/events/' + eventId);
  }
  randomNew(codes) {
    var code = codes[Math.floor(Math.random() * codes.length)];
    var site = Math.floor(Math.random() * 12500);
    console.log('Event generator', code.code, 'siteid', site);
    this.create(site, {
      code: code.code,
      details: {},
    });
  }
  download(siteId, params = null) {
    var searchParams = new URLSearchParams(params);
    searchParams.delete('page');
    let source = Axios.CancelToken.source();
    setTimeout(() => {
      source.cancel();
    }, 30000);

    const query = searchParams.toString();
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const headers = {"X-Content-Timezone":tz}
    if (siteId) {
      return httpClient.get(`v1/sites/${siteId}/events/download?${query}`, {
        responseType: 'blob',
        headers: headers,
        cancelToken: source.token,
      });
    } else {
      return httpClient.get(`v1/events/download?${query}`, {
        responseType: 'blob',
        headers: headers,
        cancelToken: source.token,
      });
    }
  }
}

export default new EventService();
